import styled, { css } from 'styled-components';
import { DropDownIcon, CloseIcon } from 'assets/icons';

import { Field } from 'components/ui/controls/SearchTickets';
import { Text } from 'components/ui/controls/SearchTickets/TextField/TextField.styles';

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: -1px;
  right: -1px;
  background-color: #ffffff;
  border-radius: 0 0 4px 4px;
  overflow: auto;
  max-height: 184px;
  z-index: 2;
`;

export const TextFieldWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 100%;
  border-radius: 4px 4px 0 0;

  ${DropDownIcon} {
    cursor: pointer;
    position: absolute;
    pointer-events: none;
    right: 16px;
    width: 16px;
    height: 12px;
    transform: rotate(0);
  }

  ${CloseIcon} {
    cursor: pointer;
    position: absolute;
    right: 16px;
    width: 16px;
    height: 16px;
    fill: #a5a9b2;
  }
`;

const Wrapper = styled.div`
  position: relative;
  border-radius: 5px;
  border: ${(p) => !p.$withOutBorder && '1px solid #dee3ee'};
  background: ${(p) => p.$withOutBorder && '#f2f4f6'};
  width: 100%;

  ${Field} {
    width: 100%;
  }

  ${(p) =>
    p.$error &&
    css`
      border: 1px solid #dd6369;
    `}

  ${(p) =>
    p.$opened &&
    css`
      border-radius: 4px 4px 0 0;
      border-top: 1px solid #0076be;
      border-left: 1px solid #0076be;
      border-right: 1px solid #0076be;
      z-index: 2;

      ${TextFieldWrapper} {
        background-color: #ffffff;
        ${DropDownIcon} {
          transform: rotate(180deg);
        }
      }

      ${OptionsContainer} {
        border-top: 1px solid #f2f4f6;
        border-bottom: 1px solid #0076be;
        border-left: 1px solid #0076be;
        border-right: 1px solid #0076be;
      }
    `}
  
  ${(p) =>
    p.$disabled &&
    css`
      background-color: #f2f4f6;
      border: 1px solid transparent;
      pointer-events: none;

      ${Text} {
        color: #999ea6;
      }
    `}
`;

export const Title = styled.div`
  font-size: 16px;
  line-height: 19px;
  color: #3d3f43;
`;

export const Option = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  padding: 8px 16px 8px 12px;
  border: 1px solid #f2f4f6;
  cursor: pointer;
  &:hover {
    background-color: #f2f4f6;
  }
`;

export default Wrapper;
